import { FC, useContext, useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import HubHeader from '../components/header';
import HubFooter from "../components/footer";
// import GuestTopHeader from "src/components/guestTopHeader";
import TawkToMessengerComp from "src/components/tawk.to";

import { AuthContext } from "../context/authContext";
import { AuthenticatedRoutes, ManufacturerRoutes } from "../routes/AppRoutes";
import { AppRoute } from "src/routes/types";
import {USER_TYPES} from "../constants";


const WithHeaderandFooter: FC<{ WrappedComponent: FC }> = ({ WrappedComponent }): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [mountTawk, updateMount] = useState(false);
  const [showBanner, setShowBanner] = useState(true)

  const { isUserAuthorized, isManufacturer, isRestoreCalled, userData, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const isSingleSignOn = localStorage.getItem("fromSingleSignOn")
  const handleCloseBanner = () => {
    setShowBanner(false); // will reset on refresh or revisit
  };

  useLayoutEffect(() => {
    if (!localStorage.getItem("token")) {
      if (
        window.location.pathname === "/" ||
        [...ManufacturerRoutes, ...AuthenticatedRoutes].find((route) => route.route === window.location.pathname)
      ) {
        const redirect_url = process.env.REACT_APP_PUBLIC_REDIRECT_URL
        if (redirect_url) window.location.replace(redirect_url)
      }
    }
  }, [])


  const navigateToTargetedRoute = (RouteListing: AppRoute[]) => {
    const indexRoute = RouteListing.find((route) => route.isIndex);
    const currentRoute = RouteListing.find((route) => {
      const firstCheck = route.route.includes(pathname);
      if (route.route.includes(":")) {
        const checkForRoute = route.route.replace(/:([a-z]+)\/?/gi, "/").replace(/\//g, "");
        const checkForPathname = pathname.replace(/[0-9]/g, "").replace(/\//g, "");
        const secondCheck = checkForRoute === checkForPathname;
        return firstCheck || secondCheck;
      } else {
        return firstCheck;
      }
    });

    if (indexRoute) {
      if (currentRoute) navigate(pathname + search);
      else {
        if (indexRoute.route.includes("sign_in")) {
          const redirect_url = process.env.REACT_APP_PUBLIC_REDIRECT_URL
          if (redirect_url) window.location.replace(redirect_url)
          else navigate(indexRoute.route)
        } else {
          navigate(indexRoute.route);
        }
      }
    }
  };

  const checkForAuthentication = () => {
    if (!isUserAuthorized) {
      // navigateToTargetedRoute(PublicRoutes);
    } else {
      if (isSingleSignOn) {
        if (isManufacturer) {
          navigateToTargetedRoute(ManufacturerRoutes);
        } else {
          navigateToTargetedRoute(AuthenticatedRoutes);
        }
      } else {
        if (userData?.is_password_changed === false) {
          navigate("/users/createuser");
        } else if (isManufacturer) {
          navigateToTargetedRoute(ManufacturerRoutes);
        } else {
          navigateToTargetedRoute(AuthenticatedRoutes);
        }
      }
    }
  };

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      navigate(pathname + search);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoreCalled]);

  useEffect(() => {
    if (isUserAuthorized && userData && !USER_TYPES.MANUFACTURER.includes(userData.ref_type)) updateMount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);



  return (
    <>
      <header className="sticky-top">
        <HubHeader />
      </header>
      {/* { <div>{showBanner && !isManufacturer && isUserAuthorized && (
          <div className="alert alert-warning auto-save-banner d-flex align-items-start justify-content-between">
            <div>
              <h4 className="alert-heading mb-2 fs-4 fst-italic">Important Medicare Eligibility Verification Notice</h4>
              <p className="fst-italic fw-bold">
                Elusa Health is currently working through updated CMS HETS registration and attestation requirements
                impacting Medicare eligibility verification transactions.
                <br/>
                During this period, Medicare eligibility verification may be temporarily unavailable through our standard
                electronic verification process. While Elusa Health continues working to restore full connectivity,
                provider offices may need to verify Medicare eligibility and benefits directly using their existing
                internal processes.
                <br/>
                Please note that Elusa Health can continue supporting commercial and secondary coverage verification
                activities during this time.
                <br/>
                Our team is actively monitoring the situation and working closely with our technology and connectivity
                partners to minimize disruption to patient support services.
                <br/>
                We appreciate your partnership and patience as the industry works through these CMS changes. Please
                contact our team with any questions.
              </p>
            </div>
            <button type="button" className="btn bi bi-x-lg fs-5 p-0" onClick={handleCloseBanner}></button>
          </div>
      )}</div> } */}
      <WrappedComponent />
      {mountTawk ? <TawkToMessengerComp /> : null}
      <HubFooter />
    </>
  );
}


export default WithHeaderandFooter;
